import React, {useContext} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AppMenu from './AppMenu'
import {BtnLogoHori} from "./Buttons/Logo/BtnLogoHori";
import {ThemeContext} from "styled-components";
import { AppBarContext } from '../../../App';
import {AuthContext} from "../../auth/providers/AuthProvider";
import GroupSelectorCompact from './GroupSelectorCompact';

const Header = React.memo(() => {
    const theme = useContext(ThemeContext);
    const appBarRef = useContext(AppBarContext);
    const { authClaims } = useContext(AuthContext);

    return (
        <>
        <AppBar ref={appBarRef} sx={{background: theme.colors.headerBg, zIndex: "1250"}} position="fixed">
            <Toolbar 
                sx={{ 
                    minHeight: '48px',
                    height: '48px',
                    padding: { xs: '0 8px', sm: '0 16px' },
                    '&.MuiToolbar-root': {
                        minHeight: '48px',
                        height: '48px',
                    }
                }}
            >
                <BtnLogoHori/>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    {/*TODO: this is required for header spacing*/}
                </Typography>
                {authClaims && (
                    <GroupSelectorCompact />
                )}
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    {/*TODO: this is required for header spacing*/}
                </Typography>
                <Box
                    component="div"
                    aria-label="menu"
                    sx={{
                        mr: 2
                    }}
                >
                    <AppMenu/>
                </Box>
            </Toolbar>
        </AppBar>
        </>
    );
});
export default Header;
